import styled from 'styled-components';

export const Card = styled.div`
  font-family: Poppins, sans-serif;
  width: 470px;
  aspect-ratio: 8/5;
  box-shadow: 0 1px 30px rgba(181, 189, 212, 0.4);
  display: flex;
  flex-direction: row;
  background-color: #fff;
  border-radius: 4px;
  transition: 400ms ease;
  overflow: hidden;
  cursor: ${props => (props.pointer ? 'pointer' : 'default')};
  &:hover {
    box-shadow: 0 10px 50px rgba(181, 189, 212, 0.8);
  }
`;

Card.Left = styled.div`
  background-color: silver;
`;

Card.Body = styled.div`
  flex: 0 0 60%;
  gap: 5px;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

Card.Thumbnail = styled.div`
  flex: 0 0 40%;
  overflow: hidden;
`;

Card.Date = styled.p`
  font-size: 13px;
  line-height: 14px;
  font-style: italic;
`;

Card.Name = styled.h5`
  font-weight: bold;
  line-height: 20px;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
`;

Card.Subject = styled.h5`
  line-height: 16px;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
`;

Card.AB = styled.span`
  color: #61ac04;
  text-align: left;
  font-size: 12px;
  padding: 5px 10px;
  font-weight: bold;
  border-radius: 10px;
  background-color: #f7ffe4;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 5px;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;

CardHeader.Left = HeaderActions;
CardHeader.Right = HeaderActions;

export const RowSpaceBetween = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ColumnSpaceBetween = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-bottom: 10px;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: auto;
  gap: 10px;
`;

export const Button = styled.button`
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  padding: 8px 18px;
  border-radius: 3px;
  text-align: center;
  align-self: flex-end;
  color: ${({ light }) => (light ? '#007ade' : 'white')};
  background-color: ${({ light }) => (light ? 'white' : '#007ade')};
  border: 1px solid #007ade;
  transition: all 0.3s ease-in;
  line-height: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: auto;
  &:hover,
  &.active {
    cursor: pointer;
    color: ${({ light }) => (light ? 'white' : '#007ade')};
    background-color: ${({ light }) => (light ? '#007ade' : 'white')};
    border: 1px solid #007ade;
  }
`;

export const CancelButton = styled.button`
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  padding: 6px 14px;
  border-radius: 2px;
  text-align: center;
  align-self: flex-end;
  color: #ff6161;
  background-color: white;
  border: 1px solid #ff6161;
  transition: all 0.3s ease-in;
  line-height: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: auto;
  &:hover,
  &.active {
    cursor: pointer;
    color: white;
    background-color: #ff6161;
    border: 1px solid #ff6161;
  }
`;

export const Date = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
  color: #ffae00;
  padding: 5px 10px;
  font-weight: bold;
  border-radius: 10px;
  background-color: #fff9e3;
  font-size: 12px;
  line-height: 13px;
`;
